import React, { memo } from 'react';
import './demandPlannerYoySec.scss';

const MskuCagrDataTable = memo((props) => {

    const valueChecker = (value) => {
        if (value > 0) {
            return 'positive-value'
        }
        else if (value < 0) {
            return 'negative-value'
        }
        else {
            return 'zero-value'
        }
    }

    return (
        <table className='msku-info-table'>
            <thead>
                <tr>
                    <th className='header-bg-1 msku-cell fix-top-0'>CAGR</th>
                </tr>
                <tr>
                    <th className='header-bg-2 msku-cell fix-top-24'>3 Years CAGR</th>
                </tr>
            </thead>
            <tbody>
                {
                    props.data && props.data.Brands.map((brand, index) => (
                        <React.Fragment key={'z' + index}>
                            {
                                Object.values(brand.MasterSkus.reduce((r, a) => {
                                    r[a.Format] = [...r[a.Format] || [], a];
                                    return r;
                                }, {}))
                                    .map(item => (
                                        item.map((msku, indx) => (
                                            <React.Fragment key={'y' + indx}>
                                                <tr key={'a' + indx} className='row-right-border'>
                                                    <td key={'a-a' + indx} className={`msku-cell msku-cell-bg-white ${valueChecker(msku[props.objKey])}`}>
                                                        {msku[props.objKey] || msku[props.objKey] === 0 ? `${msku[props.objKey]?.toFixed(2)}%` : ''}
                                                    </td>
                                                </tr>
                                                {
                                                    item.length - 1 === indx ?
                                                        (
                                                            <tr key={'b' + indx} className='highlight-row-bg-blue row-right-border'>
                                                                {
                                                                    brand.FormatData.filter(format => format.FormatName === msku.Format)
                                                                        .map(elm => (
                                                                            <td key={'b-b' + indx} className='msku-cell'>
                                                                                {elm[props.objKey] || elm[props.objKey] === 0 ? `${elm[props.objKey]?.toFixed(2)}%` : ''}
                                                                            </td>
                                                                        ))
                                                                }
                                                            </tr>
                                                        )
                                                        :
                                                        null
                                                }
                                            </React.Fragment>
                                        ))
                                    ))
                            }
                            {
                                brand.VariantData.map((variant, varInd) => (
                                    <tr key={'c' + varInd} className='highlight-row-bg-green row-right-border'>
                                        <td key={'c-c' + varInd} className={`msku-cell ${valueChecker(variant[props.objKey])}`}>
                                            {variant[props.objKey] || variant[props.objKey] === 0 ? `${variant[props.objKey]?.toFixed(2)}%` : ''}
                                        </td>
                                    </tr>
                                ))
                            }
                            <tr key={'d' + index} className='highlight-row-bg-grey row-right-border'>
                                <td className={`msku-cell ${valueChecker(brand[props.objKey])}`}>
                                    {brand[props.objKey] || brand[props.objKey] === 0 ? `${brand[props.objKey]?.toFixed(2)}%` : ''}
                                </td>
                            </tr>
                        </React.Fragment>
                    ))
                }
                {
                    props.data && (
                        <tr className='highlight-row-bg-orange row-right-border'>
                            <td className={`msku-cell ${valueChecker(props.data.Category[props.objKey])}`}>
                                {props.data.Category[props.objKey] || props.data.Category[props.objKey] === 0 ? `${props.data.Category[props.objKey]?.toFixed(2)}%` : ''}
                            </td>
                        </tr>
                    )
                }
            </tbody>

        </table>
    );
})

export default MskuCagrDataTable;